export const imageUploadUrl = '/file/upload/user_post/user_post/field_images'
export const videoUploadUrl = '/file/upload/paragraph/video/field_video_secure'
export const coverUploadUrl = '/file/upload/paragraph/video/field_thumbnail'
export const profileVideoUploadUrl = '/file/upload/paragraph/video/field_video_secure'